import { Mic } from 'lucide-react';

export default function AudioLayerRenderer({ layer }) {
  const data = layer.data;

  return (
    <div style={{
      width: '100%', height: '100%',
      background: 'rgba(99,102,241,0.15)',
      border: '1px solid rgba(99,102,241,0.3)',
      borderRadius: 8,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    }}>
      <Mic size={14} className="text-indigo-400" />
      <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>
        {data.src ? 'Audio' : 'No audio'}
      </span>
    </div>
  );
}
